import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const addDupeVehicle = createAction(actionType.ADD_DUPE_VEHICLE);
const removeDupeVehicle = createAction(actionType.REMOVE_DUPE_VEHICLE);
const clearDupeVehicle = createAction(actionType.CLEAR_DUPE_VEHICLE);

export { addDupeVehicle, removeDupeVehicle, clearDupeVehicle };
